/** 예전 프로덕션 Vercel URL — OAuth·Storage 도메인 불일치 방지용 */
const LEGACY_PROD_HOSTS = new Set(['mingo-app-theta.vercel.app']);

const FALLBACK_PROD_ORIGIN = 'https://www.mingolife.app';

/** Vercel 빌드 시 주입: `www.mingolife.app` (scheme 없음) */
function productionOriginFromEnv() {
  const raw = String(process.env.REACT_APP_VERCEL_PROJECT_PRODUCTION_URL || '').trim();
  if (!raw) return '';
  const host = raw.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
  return host ? `https://${host}` : '';
}

/** OAuth redirectTo·비밀번호 재설정 등에 쓸 canonical origin */
export function getAppOrigin() {
  const fromEnv = productionOriginFromEnv();
  if (fromEnv) return fromEnv;

  if (typeof window !== 'undefined' && window.location?.origin) {
    const host = window.location.hostname;
    if (LEGACY_PROD_HOSTS.has(host)) return FALLBACK_PROD_ORIGIN;
    return window.location.origin;
  }

  return FALLBACK_PROD_ORIGIN;
}

export function authCallbackUrl() {
  return `${getAppOrigin()}/auth/callback`;
}

export function resetPasswordUrl() {
  return `${getAppOrigin()}/reset-password`;
}

/** OAuth hash 보존하며 예전 vercel 프로덕션 호스트 → mingolife.app */
export function redirectLegacyProdHostIfNeeded() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (!LEGACY_PROD_HOSTS.has(host)) return false;

  const target = `${FALLBACK_PROD_ORIGIN}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(target);
  return true;
}
